import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=2e320b98&scoped=true&"
import script from "./tenant.vue?vue&type=script&lang=js&"
export * from "./tenant.vue?vue&type=script&lang=js&"
import style0 from "./tenant.vue?vue&type=style&index=0&id=2e320b98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e320b98",
  null
  
)

export default component.exports